export default "__VITE_ASSET__cTolRQ$n__"